import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-244">
      <div className="max-w-3xl mx-auto text-center" data-id="element-245">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8" data-id="element-246">
          Si sos profe de folklore en Argentina,
          <br data-id="element-247" />
          <span className="text-[#FF6B00]" data-id="element-248">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-3 text-left mb-10" data-id="element-249">
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-250">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-251">❌</span>
            <p className="text-white text-base" data-id="element-252">
              Perdés todos los domingos buscando material y el lunes llegás con
              algo improvisado
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-253">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-254">❌</span>
            <p className="text-white text-base" data-id="element-255">
              Temas difíciles (zapateo, zarandeo, malambo) sin progresión ni
              material diferenciado por nivel
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-256">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-257">❌</span>
            <p className="text-white text-base" data-id="element-258">
              El 70% de los alumnos abandona antes del año y no sabés cómo
              prevenirlo
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-259">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-260">❌</span>
            <p className="text-white text-base" data-id="element-261">
              Actos escolares y muestras de fin de año organizados en caos, sin
              guiones ni plan
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-262">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-263">❌</span>
            <p className="text-white text-base" data-id="element-264">
              No podés justificar un aumento porque no tenés un sistema
              profesional visible
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-265">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-266">❌</span>
            <p className="text-white text-base" data-id="element-267">
              Siempre las mismas correcciones improvisadas, sin método claro que
              te respalde
            </p>
          </div>
        </div>

        <p className="text-[#FF6B00] text-2xl sm:text-3xl font-black mb-8" data-id="element-268">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B00] to-transparent w-full" data-id="element-269" />
      </div>
    </section>;
}